import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Card } from '@utx/utx-access-client';
import { MobileNo } from '@/features/account-management/types';
import { phoneNumberProp } from '@/features/account-management/screens/details/hooks/useCard.hook';

export interface UpdateMobileNoModalProps {
  onLayout: (event: any) => void;
}

export enum UpdateMobileNoStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed'
}

export type UpdateMobileNoStackParamList = {
  [UpdateMobileNoStackRoutes.Main]: UpdateMobileNoModalProps & {
    record?: Card;
    onData: (data: MobileNo) => void;
    func?: (cardId: string, phoneNumber: phoneNumberProp, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [UpdateMobileNoStackRoutes.Confirm]: UpdateMobileNoModalProps & {
    record?: Card;
    data: MobileNo;
    func?: (cardId: string, phoneNumber: phoneNumberProp, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [UpdateMobileNoStackRoutes.Placed]: UpdateMobileNoModalProps & {
    record?: Card;
    data: MobileNo;
    returnData?: any;
    refresh?: () => void;
  };
};

export type UpdateMobileNoStackScreenProps<Screen extends keyof UpdateMobileNoStackParamList> = NativeStackScreenProps<
  UpdateMobileNoStackParamList,
  Screen
>;
